import React from "react";
// import { CircleCharts } from "../../../../../_metronic/_partials/widgets";
import {
  SavedJobs,
  SavedResumes,
  SavedOccupations,
  Assessment,
  StatsOverview,
  ClientListTable,
  // InviteJobSeeker,
} from "./components";
import { Grid } from "@material-ui/core";
import { UserProfile } from "./components/UserProfile";
import { UploadDocument } from './components'
import { useParams } from "react-router-dom";
import { FetchClient } from "../Dashboard/apis";

export function ClientProfile() {
  const [selectedUserData, setSelectedUserData] = React.useState({})
  const [selectedUser, setSelectedUser] = React.useState("");

  const params = useParams().id
  const [user, setUser] = React.useState()

  const fetchUser = async () => {
    let newuser = await FetchClient(params)
    newuser = newuser.data;
    console.log("user:-=-=-= test", newuser)
    if (newuser && newuser.type.toLowerCase() === 'job seeker' || newuser.type === "JOB_SEEKER") {
     setSelectedUser(newuser._id)
    }
    setUser(newuser)
  }

  React.useEffect(() => {
    if (params) {
      fetchUser()
    }
  }, [])
  // console.log("selectedUser", selectedUser, "selectedUserData", selectedUserData)
  return (
    <>
      {/* <div className="row gutter-b justify-content-center">
        <div className="col-sm-8">
          <InviteJobSeeker />
        </div>
      </div> */}
     {user && (user.type === 'COACH' || user.type.toLowerCase() === 'coach') && <Grid container direction="column" spacing={5} className="mb-5">
        <Grid item>
          <StatsOverview user={user} />
        </Grid>

        <Grid item>
          <ClientListTable setSelectedUser={setSelectedUser} user={user} />
        </Grid>
      </Grid>}
      {selectedUser ? (
        <Grid container direction="column" spacing={5}>
          <Grid item>
            {/* <UserProfile
              selectedUser={selectedUser}
              setSelectedUserData={setSelectedUserData}
            /> */}
          </Grid>
          <Grid item>
            <UploadDocument user={selectedUser} />
          </Grid>
          <Grid item>
            <SavedOccupations selectedUser={selectedUser} />
          </Grid>
          <Grid item>
            <SavedResumes selectedUser={selectedUser} />
          </Grid>
          <Grid item>
            <SavedJobs selectedUser={selectedUser} />
          </Grid>
          {/* <Grid item>
            <Assessment selectedUserData={selectedUserData} />
          </Grid> */}
        </Grid>
      ) : (
        <div></div>
      )}
      {/* <div className="row gutter-b">
        <div className="col-sm-12">
          <CircleCharts />
        </div>
      </div> */}

      {/* <div className="row gutter-b">
        <div className="col-sm-12">
          <SavedJobs />
        </div>
      </div> */}
      {/* <div className="row gutter-b">
        <div className="col-sm-12">
          <Assessment />
        </div>
      </div> */}
    </>
  );
}
